export default [
  {
    path: '/site',
    name: 'Site',
    meta: { title: '站点后台', requireAuth: true, requireSiteAdmin: true },
    component: () => import('@/views/site/site.vue'),
    children: [
      {
        path: '',
        redirect: '/site/dashboard'
      },
      {
        path: 'dashboard',
        name: 'SiteDashboard',
        component: () => import('@/views/site/dashboard/dashboard.vue'),
        meta: { title: '站点后台', tabbar: 'dashboard' }
      },
      {
        path: 'user',
        name: 'SiteUser',
        component: () => import('@/views/site/user.vue'),
        meta: { title: '用户', tabbar: 'user' }
      },
      {
        path: 'order',
        name: 'SiteOrder',
        component: () => import('@/views/site/order.vue'),
        meta: { title: '订单', tabbar: 'order' }
      }
    ]
  }
]
